:host {
  --aha-ez-tab-panel--padding: var(--spacer-4);

  display: block;
  box-sizing: border-box;
  padding: var(--aha-ez-tab-panel--padding);
}
:host([aria-hidden='true']) {
  display: none !important; /* Using !important because we always want hidden panels to disappear from the DOM */
}
